import { useEffect, useState } from 'react';
import _ from 'lodash';
import OfferEntry from '../offerEntry/OfferEntry';
import { flattenTransferOffers } from '../../utils';
import type { CruiseOffers } from '@/model/upsell/transfer';

// Styles
import './offer-list.scss';

interface OfferListProps {
    cruiseOffers: CruiseOffers;
    onSelection: (offerKey: string) => void;
    selectedOffer: string | null;
}

const OfferList = ({ cruiseOffers, onSelection, selectedOffer }: OfferListProps) => {
    const [view, setView] = useState('list');

    useEffect(() => {
        function setViewType() {
            if (window.innerWidth >= 920) {
                setView('desktop');
            }
            if (window.innerWidth <= 920) {
                setView('mobile');
            }
        }
        if (typeof window !== 'undefined') {
            window.addEventListener(
                'resize',
                _.debounce(() => setViewType(), 200)
            );
        }
        setViewType();
    }, []);

    const headers = [
        { label: 'Transfer Option', key: 'label', className: 'transfer-option' },
        { label: 'Preis', key: 'price' },
        { label: 'Details', key: 'details', className: 'details' },
        { label: 'Dauer', key: 'transferTime' },
        { label: 'Auswahl', key: 'selection' },
    ];

    const offers = flattenTransferOffers(cruiseOffers).map((transferOffer) => (
        <OfferEntry
            key={transferOffer.offerKey}
            transferOffer={transferOffer}
            onSelection={onSelection}
            selectedOffer={selectedOffer}
        />
    ));

    return (
        <div className="offer-list-container">
            <div className="list-header">
                {view === 'mobile' ? (
                    <>
                        {headers.slice(0, 1).map((header) => (
                            <div key={header.key} {...(header.className && { className: header.className })}>
                                {header.label}
                            </div>
                        ))}
                    </>
                ) : (
                    <>
                        {headers.map((header) => (
                            <div key={header.key} {...(header.className && { className: header.className })}>
                                {header.label}
                            </div>
                        ))}
                    </>
                )}
            </div>
            <div className="offers">{offers}</div>
        </div>
    );
};

export default OfferList;
